import moment from "moment"

import { isEmpty } from "./stringRegex"

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_PRINT_FORMAT = 'DD/MM/YYYY'

export function isNotValidScadenzaPolizza (d: string | undefined) {

    return isEmpty(d) || 
            moment().isAfter(moment(d, DATE_FORMAT), 'day') ||
            moment(d, DATE_FORMAT).isAfter( moment().add(1, 'months'), 'day')
}

export function isNotValidInizioPolizza (d: string | undefined) {
    const deviation = moment(new Date()).add(3, 'days')

    return isEmpty(d) || 
            deviation.isAfter( moment(d, DATE_FORMAT), 'day' ) ||
            moment(d, DATE_FORMAT).isAfter( deviation.add(1, 'months'), 'day')
}

export function isNotValidDataInzioViaggio (s: string | undefined, e: string | undefined) {
    if (isEmpty(s)) {
        return true
    }

    const now = moment()
    const mStart = moment(s, DATE_FORMAT)

    return now.isSameOrAfter(mStart, 'day')
}
export function isNotValidDataFineViaggio (s: string | undefined, e: string | undefined) {
    if (isEmpty(e)) {
        return true
    }

    const now = moment()
    const mEnd = moment(e, DATE_FORMAT)

    if (s !== undefined) { 
        /*
         se ho una data di inizio
         -- FINE deve essere maggiore di INIZIO.
        */
        const mStart = moment(s, DATE_FORMAT).add(1, 'day')

        return (
            now.isAfter(mStart, 'day') ||
            mStart.isAfter(mEnd, 'day')
        )
    }
    else { 
        /*
         se NON ho una data di inizio 
        -- la data di fine deve comunque essere maggiore di OGGI (se no so partito ieri)
        */
        return now.isAfter(mEnd, 'day')
    }
}

export function isNotValiDataNascita (d: string | undefined) {
    if ( isEmpty(d) ) {
        return true; // nno è valida
    }

    const MAX_DATA_NASCITA = moment().subtract(18, 'year').format(DATE_FORMAT)
    const MIN_DATA_NASCITA = moment().subtract(100, 'year').format(DATE_FORMAT)

    const input = moment(d, DATE_FORMAT)

    // non è valida se è successiva al massimo o precedente al minimo
    return input.isSameOrAfter(MAX_DATA_NASCITA) || input.isSameOrBefore(MIN_DATA_NASCITA)
}

export function isAfterCurrentYear (val: number) {
    return moment().year() < Number(val)
}

export function annoRistrutturazioneValidation (
    isRistrutturato: boolean | undefined,
    anno_costruzione: string | undefined,
    anno_ristrutturazione: number | undefined
) {
    let error = undefined

    if (
        isRistrutturato === true && 
        anno_costruzione !== undefined &&
        anno_ristrutturazione !== undefined
    ) {
        if (
            isAfterCurrentYear(anno_ristrutturazione) ||
            (anno_costruzione === 'prima1970' && Number(anno_ristrutturazione) === 1970) ||
            (anno_costruzione === '1970_1980' && Number(anno_ristrutturazione) <= 1970) ||
            (anno_costruzione === '1980_1990' && Number(anno_ristrutturazione) <= 1980) ||
            (anno_costruzione === '1990_2000' && Number(anno_ristrutturazione) <= 1990) ||
            (anno_costruzione === '2000_2010' && Number(anno_ristrutturazione) <= 2000) ||
            (anno_costruzione === '2010_2020' && Number(anno_ristrutturazione) <= 2010) ||
            (anno_costruzione === 'dopo2020' && Number(anno_ristrutturazione) <= 2020)
        ) {
            error = 'Anno non valido'
        }
    }

    return error
}